import React from 'react';
import Sections from './sections';

const PagebuilderAfterContent = ({
  afterContentSections = [],
}) => {
  if (((afterContentSections || []).length > 0)) {
    return (
      <Sections sections={afterContentSections} />
    );
  }
  return null;
};

export default PagebuilderAfterContent;
